import { uniqueId } from 'lodash';

import { publicEnv } from '@/lib/env';
import { WORLD_PICKLEBALL_RANKINGS } from '@/modules/rankings/constants';

export enum PprDivisionType {
  WomensSingles = '1',
  MensSingles = '2',
  Mixed = '3',
  WomensDoubles = '4',
  MensDoubles = '5',
}

export const PLAYER_PROFILE_DIVISION_TYPES = [
  {
    id: uniqueId(),
    title: WORLD_PICKLEBALL_RANKINGS,
    femaleType: null,
    maleType: null,
  },
  {
    id: uniqueId(),
    title: 'Current Doubles Seed',
    femaleType: '4',
    maleType: '5',
  },
  {
    id: uniqueId(),
    title: 'Current Mixed Seed',
    femaleType: '3',
    maleType: '3',
  },
  {
    id: uniqueId(),
    title: 'Current Singles Seed',
    femaleType: '1',
    maleType: '2',
  },
];

export const DEFAULT_PROFILE_IMAGE = `${publicEnv.NEXT_PUBLIC_IMAGE_CDN_URL}/global/legacy/profile-image.svg`;

export const PLAYER_LEVELS = [
  {
    id: '1',
    title: 'Eligible Pro',
    displayOrder: 3,
    isEnabled: true,
    isPro: true,
  },
  {
    id: '2',
    title: 'Senior Pro',
    displayOrder: 4,
    isEnabled: true,
    isPro: true,
  },
  {
    id: '3',
    title: 'Junior',
    displayOrder: 5,
    isEnabled: true,
    isPro: true,
  },
  {
    id: '4',
    title: 'Amateur',
    displayOrder: 1,
    isEnabled: true,
    isPro: false,
  },
  {
    id: '5',
    title: 'Tour Pro',
    displayOrder: 2,
    isEnabled: true,
    isPro: true,
  },
  {
    id: '6',
    title: 'Retired Pro',
    displayOrder: 6,
    isEnabled: true,
    isPro: false,
  },
];

export const DONUT_CHART_COLORS = {
  doubles: '#311482',
  singles: '#5a2ee5',
  mixed: '#7042e4',
  textMain: '#111827',
  textSecondary: '#4b5563',
  lineColor: '#e5e7eb',
} as const;

export const NO_RESULTS_DESCRIPTION = 'There are no results for this bracket level';
export const BEST_TOURNAMENTS_COUNT = 14;

export const RANKING_HISTORY_STANDINGS_TYPES = [
  {
    id: uniqueId(),
    title: 'Doubles Results (50%)',
    femaleType: '4',
    maleType: '5',
  },
  {
    id: uniqueId(),
    title: 'Mixed Results (35%)',
    femaleType: '3',
    maleType: '3',
  },
  {
    id: uniqueId(),
    title: 'Singles Results (15%)',
    femaleType: '1',
    maleType: '2',
  },
];

export const TWO_DASHES_PLACEHOLDER = '--';
export const ONE_DASH_PLACEHOLDER = '-';
export const DEFAULT_BRACKET_PRO_LEVEL_ID = '2';
